// extracted by mini-css-extract-plugin
export default {"big_card":"BigCardBanner_big_card__CWB8a","link":"BigCardBanner_link__Chmop"};